import { Pill, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import SwipeableViews from "react-swipeable-views";

import { BadgePolicyCard } from "./BadgePolicyCard";
import { StepIndicatorDots } from "./StepIndicatorDots";

export interface BadgePolicyCardsProps {
  activeStep: number;
  setActiveStep: (step: number) => void;
}

export function BadgePolicyCards(props: BadgePolicyCardsProps) {
  const { activeStep, setActiveStep } = props;

  return (
    <>
      <SwipeableViews enableMouseEvents index={activeStep} onChangeIndex={setActiveStep}>
        <BadgePolicyCard title="How the policy works">
          <Stack spacing={4}>
            <Text bold variant="body1">
              A workplace with this policy requires you to wear a badge while working.
            </Text>
            <Text bold variant="body1">
              Before clocking in, you&apos;ll take a quick photo of your badge on your work attire.
              This photo will be shared with the workplace to confirm compliance.
            </Text>
          </Stack>
        </BadgePolicyCard>
        <BadgePolicyCard title="How the policy impacts you">
          <Stack spacing={4}>
            <Text variant="body1">
              You&apos;ll earn Clipboard Score points if you follow the policy. You&apos;ll lose
              them if you don&apos;t.
            </Text>

            <Stack spacing={2} px={2}>
              <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Text bold variant="body1">
                  Wearing a badge on shift
                </Text>
                <Pill
                  label="+5 pts"
                  size="small"
                  variant="filled"
                  color={(theme) => theme.palette.intent?.success.text}
                  backgroundColor={(theme) => theme.palette.intent?.success.background}
                />
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Text bold variant="body1">
                  Not wearing a badge on shift
                </Text>
                <Pill
                  label="-5 pts"
                  size="small"
                  variant="filled"
                  color={(theme) => theme.palette.intent?.error.text}
                  backgroundColor={(theme) => theme.palette.intent?.error.background}
                />
              </Stack>
            </Stack>
          </Stack>
        </BadgePolicyCard>
      </SwipeableViews>

      <StepIndicatorDots activeStep={activeStep} totalSteps={2} />
    </>
  );
}
